export const diagnosticManeuverType = {
  MOTOR: 0,
  CLOSING: 1,
  OPENING: 2,
};

export const diagnosticVariable = {
  UNDEFINED: 0,
  TEMPO_MOVIMENTACAO_CONTATO: 1,
  TEMPO_INTERRUPCAO_CORRENTE: 2,
  TEMPO_ARCO: 3,
  TEMPO_CORTE_CORRENTE_BOBINA: 4,
  RESISTENCIA_BOBINA: 5,
  TENSAO_MINIMA_BOBINA: 6,
  TENSAO_MAXIMA_BOBINA: 7,
  STROKE_POLO: 8,
  OVERTRAVEL_POLO: 9,
  REBOUND_POLO: 10,
  TEMPO_OVERTRAVEL_POLO: 11,
  TEMPO_REBOUND_POLO: 12,
  TEMPO_AMORTECIMENTO_POLO: 13,
  TEMPO_INICIO_MOVIMENTO_POLO: 14,
  TEMPO_CONTATO_AUXILIAR_DJA: 15,
  TEMPO_CONTATO_AUXILIAR_DJB: 16,
  VELOCIDADE_MEDIA: 17,
  TEMPO_ESTABELECIMENTO_CORRENTE: 18,
  TEMPO_PRE_ARCO: 19,
  TEMPO_MAGNETICO_BOBINA: 20,
  STROKE_EIXO_FECHAMENTO: 21,
  OVERTRAVEL_EIXO_FECHAMENTO: 22,
  TEMPO_OVERTRAVEL_EIXO_FECHAMENTO: 23,
  TEMPO_AMORTECIMENTO_EIXO_FECHAMENTO: 24,
  TENSAO_MINIMA_MOTOR: 25,
  TENSAO_MAXIMA_MOTOR: 26,
  ENERGIA_USADA_OPERACAO: 27,
  TEMPO_OPERACAO_MOTOR_CARREGAMENTO_MOLA: 28,
  TEMPO_PULSO_BOBINA: 29,
  TENSAO_MAXIMA_BOBINA_ANTES_TEMPO_MAGNETICO: 30,
  CORRENTE_MAXIMA_BOBINA_ANTES_TEMPO_MAGNETICO: 31,
  VARIACAO_CORRENTE_BOBINA_ANTES_TEMPO_MAGNETICO: 32,
  CORRENTE_MAXIMA_MOTOR: 33,
  PICO_CORRENTE_MOTOR: 34,
};
